import { Star } from "lucide-react";
import React from "react";

function StarReviewEditable({
  rating,
  size = 20,
  padding = "4px",
  onStarClick = () => {},
  dir = "ltr",
}) {
  const totalStars = 5;

  return (
    <div className="d-flex align-items-center gap-3" dir={dir}>
      {Array.from({ length: totalStars }).map((_, index) => {
        const starValue = index + 1;
        return (
          <div key={index} className="star-wrapper">
            <span
              style={{ width: size, height: size, padding }}
              className={`star star-editable ${
                starValue <= rating ? "filled" : "empty"
              }`}
              onClick={() => onStarClick(starValue)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onStarClick(starValue);
                }
              }}
              aria-label={`${starValue} of 5 stars`}
            >
              <Star fill="white" stroke="white" />
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default StarReviewEditable;
